import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent, CardContentComponent, CardHeaderComponent, CheckboxComponent } from '@nk/ui-lib';
import { CompanyCollateralChartComponent } from './company-collateral-chart.component';
import { CompanyCollateralTableComponent } from './company-collateral-table.component';

@Component({
  selector: 'nk-company-collateral-card',
  templateUrl: './company-collateral-card.component.html',
  imports: [
    FormsModule,
    TranslateModule,
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    CheckboxComponent,
    CompanyCollateralChartComponent,
    CompanyCollateralTableComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyCollateralCardComponent {
  public companyUuid = input.required<string>();
  public showForCorporateGroup = false;
  public includeDeletedCollateral = false;
}
